<template>
  <div :class="{'application':true, 'PC_width':PCWidth}">
    <div v-show="!isReady" class="loading">
      <van-loading size="72"/>
    </div>
    <!--轮播-->
    <div class="carousel">
      <van-swipe :autoplay="3000" v-if="Carouses.length>0" @change="onChange" :touchable="true" ref="swipe">
        <van-swipe-item v-for="item in Carouses" :key="'banner_'+item.ID">
          <img :src="imgUrl+item.PicturePath" @click="openUrl(item.Url)" fit="cover" width="100%" style="border-radius: 4px;" />
        </van-swipe-item>
      </van-swipe>
      <div class="swipeIndicators">
        <a v-for="(item, index) in Carouses" :key="'banner_'+item.ID" :class="current===index ? 'swipeActive':''" @click="swipToIndex(index)"></a>
      </div>
    </div>
    <!--/轮播-->
    <!--常用分类-->
    <div :class="{'applicationBox':true,'phoneApp':phoneApp}" v-for="type in CategoryApps" :key="'type_'+type.ID">
      <div class="typeIcon" :style="{'background-color':type.Color}" />
      <h1>{{getName(type)}}</h1>
      <div class="box">
        <div v-for="app in type.Applications" :key="'app_'+app.AppID" class="box-item">
          <div @click="openAppUrl(app)">
            <div class="card">
              <van-image :src="app.Logo" class="image"/>
              <p>{{getName(app)}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/常用分类-->

  </div>
</template>

<script>
import {getApplication} from '../api/client.api'
import {noticeAppOpenUrl, noticeAppOpenAppUrl, noticeAppSetDeviceData} from '../api/KdAppNative'

export default {
  name: 'index',
  data () {
    return {
      // 当前语言
      locale: this.$i18n.locale,
      // 当前语言字典
      lang: this.$i18n.messages[this.$i18n.locale],
      isReady: false,
      imgUrl: 'http://wk-res.wk.kingdraw.com/',
      Carouses: [],
      CategoryApps: [],
      language: 0,
      platform: 0,
      appVersion: '1.0',
      langType: {
        'zh-cn': 0,
        'en-us': 1
      },
      platformType: [
        {key: 0, value: 'PC'},
        {key: 1, value: 'iOS'},
        {key: 2, value: 'Ipad'},
        {key: 1, value: 'android'},
        {key: 2, value: 'Apad'},
        {key: 0, value: 'web'}
      ],
      PCWidth: false,
      phoneApp: false,
      current: 0
    }
  },
  mounted () {
    setTimeout(() => {
      try {
        // 通知App设置设备信息
        noticeAppSetDeviceData()
      } catch (e) {
        console.error('NoticeAppSetDeviceData Error', e)
      }
    }, 200)
  },
  methods: {
    fetchData () {
      getApplication({language: this.language, plantform: this.platform}).then((res) => {
        if (res.code === 200) {
          if (res.data.publish) {
            const data = JSON.parse(res.data.publish)
            console.log(data)
            this.Carouses = data.Carouses
            for (const i in data.CategoryApps) {
              let type = data.CategoryApps[i]
              let appList = []
              for (const k in type.Applications) {
                let app = type.Applications[k]
                app.Logo = this.imgUrl + app.Logo
                const name = this.getName(app)
                if (app.Url !== '' && name !== '') {
                  appList.push(app)
                }
              }
              type.Applications = appList
              if (appList.length > 0) {
                this.CategoryApps.push(type)
              }
            }
          }
        }
      })
    },
    getName (data) {
      let name = ''
      switch (this.language) {
        case 0:
          name = data.NameCN
          break
        case 1:
          name = data.NameEN
          break
      }
      return name
    },
    openUrl (url) {
      if (url !== '') {
        noticeAppOpenUrl(url)
      }
    },
    openAppUrl (data) {
      if (data.Url !== '') {
        const json = JSON.stringify(data)
        const ver = data.MinVersion
        if (ver !== '') {
          const isCheck = this.compare(this.appVersion, ver)
          if (isCheck) {
            noticeAppOpenAppUrl(json)
          } else {
            this.$toast('当前版本过低无法访问，请更新软件版本')
          }
        } else {
          noticeAppOpenAppUrl(json)
        }
      }
    },
    compare (curV, reqV) {
      if (curV && reqV) {
        // 将两个版本号拆成数字
        const arr1 = curV.split('.')
        const arr2 = reqV.split('.')
        const minLength = Math.min(arr1.length, arr2.length)
        let position = 0
        let diff = 0
        // 依次比较版本号每一位大小，当对比得出结果后跳出循环（后文有简单介绍）
        while (position < minLength && ((diff = parseInt(arr1[position]) - parseInt(arr2[position])) === 0)) {
          position++
        }
        diff = (diff !== 0) ? diff : (arr1.length - arr2.length)
        // 若curV大于reqV，则返回true
        return diff >= 0
      } else {
        // 输入为空
        console.log('版本号不能为空')
        return false
      }
    },
    changeLang (lang) {
      if (lang === 'en-us') {
        lang = 'en'
      } else {
        // 一切不是英文的都是中文 Yep!
        lang = 'zh'
      }
      // 切换当前语言
      this.$i18n.locale = lang
      this.locale = this.$i18n.locale
      this.lang = this.$i18n.messages[this.locale]
    },
    onChange (index) {
      this.current = index
    },
    swipToIndex (index) {
      this.$refs.swipe.swipeTo(index)
    }
  },
  computed: {
    header () {
      return this.$store.getters.header
    }
  },
  watch: {
    'header': {
      handler (val, oval) {
        this.changeLang(val.device.lang)
        document.title = this.lang['工作站']
        this.language = this.langType[val.device.lang] || 0
        this.platform = this.platformType[val.device.platform || 0].key
        this.appVersion = val.device.appVersion || '1.0'
        this.isReady = true
        const platform = this.platformType[val.device.platform || 0].value
        this.PCWidth = platform === 'PC'
        this.phoneApp = platform === 'iOS' || platform === 'android'
        this.fetchData()
      },
      deep: true
      // immediate: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .application{
    display: block;
    box-sizing: border-box;
    overflow: hidden;
  }
  .carousel{
    position: relative;
    display: block;
    overflow: hidden;
    padding: 0.6em 0.6em 0;
  }

  .carousel .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .carousel .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .carousel .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .applicationBox{
    display: block;
    padding: 0 0.75em;
    margin-top: 1.25em;
    clear: both;
    float: left;
    width: 100%;
  }
  .applicationBox h1{
    position: relative;
    display: block;
    padding-left: 0.63em;
    line-height: 1.5em;
    font-size: 1em;
    text-align: left;
    font-weight: 400;
    color: #000000;
  }
  .applicationBox .box{
    display: block;
    margin-left: -0.63em;
    clear: both;
  }

  .applicationBox .box .box-item{
    display: inline-block;
    float: left;
    margin: 0 0.63em;
  }
  .applicationBox .box .card{
    display: inline-block;
    margin-bottom: 0.63em;
    width: 8.44em;
    padding: 0.63em;
    height: auto;
    text-align: left;
    border-radius: 4px;
    box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.16);
    clear:both;
    zoom:1;
    cursor: pointer;
  }
  .applicationBox.phoneApp .box .box-item{
    margin: 0 0 0 0.63em;
    width: calc(50% - 1.4em);
  }
  .applicationBox.phoneApp .box .card{
    width: calc(100% - 1.3em);
  }
  .applicationBox .box .card:hover{
    background: #f3f3f3
  }
  .applicationBox .box .card::after{
    clear:both;
    display:block;
    visibility:hidden;
    height:0;
    overflow:hidden;
    content:".";
  }
  .applicationBox .box .card .image {
    display: inline-block;
    float: left;
    /*margin-bottom: 20px;*/
    width: 2.5em;
    height: 2.5em;
    border-radius: 20px;
  }
  .applicationBox .box .card .image img{
    display: block;
    width: 2.5em;
    height: 2.5em;
    border-radius: 20px;
  }
  .applicationBox .box .card p{
    display: inline-block;
    float: left;
    font-size: 0.9em;
    line-height: 2.8em;
    width: calc(100% - 3.5em);
    margin: 0 0 0 0.7em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .typeIcon{
    float: left;
    padding: 0.5em 0.13em;
    margin: 0.94em 0 0.31em 0;
    display: flex;
  }
  .loading {
    text-align: center;
    position: absolute;
    top: calc(50% - 36px);
    left: calc(50% - 36px);
  }
  .PC_width{
    padding: 0 15%;
    box-sizing: border-box;
  }

  .carousel .van-swipe{
    cursor: inherit;
  }

  .carousel .van-swipe__indicators{
    display: none!important;
  }

  .carousel .swipeIndicators{
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 7px;
    height: 20px;
    text-align: center;
  }

  .carousel .swipeIndicators a{
    display: inline-block;
    margin: 0 3px;
    width: 6px;
    height: 6px;
    background-color: #ebedf0;
    border-radius: 100%;
    opacity: 0.3;
    -webkit-transition: opacity 0.2s, background-color 0.2s;
    transition: opacity 0.2s, background-color 0.2s;
  }

  .swipeActive{
    background-color: #FFFFFF!important;
    opacity: 1!important;
  }

  @media only screen and (max-width: 1024px){
    .applicationBox .box .card:hover{
      background: none;
    }
    .applicationBox .box .card:active{
      background: #f3f3f3
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/index.vue